import React from 'react';

const NoDataModal = ({ 
    show, 
    onClose, 
    onClearFilters, 
    onCreateNew, 
    title = "No Data Found", 
    message = "No records found matching your search criteria.",
    showClearFiltersButton = true,
    showCreateButton = true,
    clearFiltersButtonText = "Clear Filters",
    createButtonText = "Create New"
}) => {
    if (!show) return null;

    return (
        <div 
            className="modal-overlay" 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1050,
                backdropFilter: 'blur(2px)'
            }}
            onClick={onClose}
        >
            <div 
                className="modal-content"
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '40px',
                    maxWidth: '500px',
                    width: '90%',
                    textAlign: 'center',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                    animation: 'modalFadeIn 0.3s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{ marginBottom: '20px' }}>
                    <i 
                        className="fa fa-search" 
                        style={{ 
                            fontSize: '48px', 
                            color: '#6c757d',
                            marginBottom: '15px'
                        }}
                    ></i>
                </div>
                
                <h4 
                    style={{ 
                        color: '#495057', 
                        marginBottom: '15px',
                        fontWeight: '600'
                    }}
                >
                    {title}
                </h4>
                
                <p 
                    style={{ 
                        color: '#6c757d', 
                        marginBottom: '30px',
                        fontSize: '14px',
                        lineHeight: '1.5'
                    }}
                >
                    {message}
                </p>
                
                
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        fontSize: '20px',
                        color: '#6c757d',
                        cursor: 'pointer',
                        padding: '5px',
                        lineHeight: '1'
                    }}
                    title="Close"
                >
                    ×
                </button>
            </div>
            
            <style jsx>{`
                @keyframes modalFadeIn {
                    from {
                        opacity: 0;
                        transform: scale(0.9) translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: scale(1) translateY(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default NoDataModal;
